import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, Menu, X } from 'lucide-react';
import { Button } from './Button';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '../utils/cn';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Available Homes',
    href: '/homes'
  }, {
    name: 'Referral Partners',
    href: '/referrals'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <>
      {/* Top Utility Bar */}
      <div className="bg-primary text-white py-2 px-6 hidden md:block" data-id="element-77">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm font-medium" data-id="element-78">
          <div className="flex items-center space-x-6" data-id="element-79">
            <a href="tel:+1234567890" className="flex items-center hover:text-accent transition-colors" data-id="element-80">
              <Phone size={14} className="mr-2" data-id="element-81" />
              (410) 555-0123
            </a>
            <a href="mailto:info@birdsnestliving.com" className="flex items-center hover:text-accent transition-colors" data-id="element-82">
              <Mail size={14} className="mr-2" data-id="element-83" />
              info@birdsnestliving.com
            </a>
          </div>
          <div className="flex items-center" data-id="element-84">
            <MapPin size={14} className="mr-2 text-accent" data-id="element-85" />
            <span data-id="element-86">Serving Communities Across Maryland</span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className={cn('sticky top-0 z-50 transition-all duration-300 px-6 py-4', isScrolled ? 'bg-white/90 backdrop-blur-md shadow-premium py-3' : 'bg-transparent')} data-id="element-87">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-88">
          <Link to="/" className="flex items-center space-x-3" data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/dzDMGWvL3pUw23BZ1V2GnL/birds_nest_rev-logo.png" alt="Birds Nest Logo" className="h-16 w-auto object-contain" data-id="element-90" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-91">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <Link key={link.name} to={link.href} className={cn('text-sm font-bold transition-all duration-300 relative py-1', isActive ? 'text-primary' : 'text-charcoal/70 hover:text-primary')} data-id="element-92">
                  {link.name}
                  {isActive && <motion.div layoutId="nav-active" className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent rounded-full" transition={{
                type: 'spring',
                stiffness: 380,
                damping: 30
              }} data-id="element-93" />}
                </Link>;
          })}
            <Button size="sm" variant="primary" to="/homes" data-id="element-94">
              Check Availability
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-95">
            {isMobileMenuOpen ? <X size={28} data-id="element-96" /> : <Menu size={28} data-id="element-97" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-98">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-full left-0 w-full bg-white shadow-2xl lg:hidden border-t border-gray-100" data-id="element-99">
              <div className="flex flex-col p-6 space-y-4" data-id="element-100">
                {navLinks.map(link => {
              const isActive = location.pathname === link.href;
              return <Link key={link.name} to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={cn('text-lg font-bold transition-colors flex items-center justify-between', isActive ? 'text-primary' : 'text-charcoal/70 hover:text-primary')} data-id="element-101">
                      {link.name}
                      {isActive && <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-102" />}
                    </Link>;
            })}
                <Button className="w-full" variant="primary" to="/homes" data-id="element-103">
                  Check Availability
                </Button>
              </div>
            </motion.div>}
        </AnimatePresence>
      </nav>
    </>;
}